'use client';

import React, { useState } from 'react';
import { Form, InputGroup, FormControl, Button } from 'react-bootstrap';
import './searchInputWithButton.scss';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

interface SearchInputWithButtonProps {
  placeholder?: string;
  buttonLabel?: React.ReactNode;
  onButtonClick?: () => void;
  buttonVariant?: string;
  inputClassName?: string;
  buttonClassName?: string;
  value?: string;
  ariaLabel?: string;
}

export const SearchInputWithButton: React.FC<SearchInputWithButtonProps> = ({
  placeholder = 'Enter text',
  buttonLabel = 'Submit',
  onButtonClick,
  inputClassName = '',
  buttonClassName = '',
  value,
  ariaLabel,
}) => {
  const [inputValue, setInputValue] = useState(value || '');
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathName = usePathname();
  const updateSearchParam = (key: string, value: string) => {
    // Create a new URLSearchParams instance with current params
    const params = new URLSearchParams(searchParams.toString());

    // Update or add the new key-value pair
    if (value) {
      params.set(key, value);
      params.set('page', '1');
    } else {
      // Remove the parameter if value is empty
      params.delete(key);
    }

    // Create the new URL using pathname instead of window.location
    const newUrl = `${pathName}?${params.toString()}`;

    // Use router.push to update the URL
    if (pathName === '/search') {
      router.push(newUrl);
    } else {
      router.push(`/search?${params.toString()}`);
    }
  };
  const handleButtonClick = () => {
    if (onButtonClick) onButtonClick();
    if (inputValue != '') {
      updateSearchParam('page', '1');
    }
    updateSearchParam('sitesearch', inputValue);
  };
  // Handle key down event for Enter key
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
      handleButtonClick();
    }
  };
  return (
    <div className="inputWithButtonComp">
      <Form className="mt-2">
        <InputGroup>
          <FormControl
            placeholder={placeholder}
            className={inputClassName}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            aria-label={ariaLabel}
            aria-live="polite"
          />
          <Button
            variant="primary"
            className={buttonClassName}
            onClick={handleButtonClick}
            aria-label="Search Resources"
          >
            {buttonLabel}
          </Button>
        </InputGroup>
      </Form>
    </div>
  );
};
